<template>
  <div class="home">
    <section class="home__container">
      <AppTitle
        :data="currentData.title"
        class="home__title"
      />
      <div
        class="home__caption button--dsk"
        data-anim="button"
      >
        <p class="button__caption">
          {{ currentData.caption }}
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import AppTitle from '@/components/AppTitle.vue';

export default {
  name: 'home',

  components: {
    AppTitle,
  },

  mounted() {
    this.$eventHub.$emit('cursorToScroll');
    if (!this.$store.state.scrollIsLocked) this.$store.commit('SET_STATE_LOCK_SCROLLING', true);
  },

  computed: {
    currentData() {
      return this.$store.state.content.find(page => page.index === 0).content;
    },
  },
};
</script>

<style lang="scss" scoped>
.home__title,
.home__caption {
  position: relative;
  grid-column-start: 4;
  grid-column-end: 13;
  text-align: center;

  @include mq(ipadL) {
    grid-column-start: 13;
    grid-column-end: 26;
    text-align: left;
  }
}

.home__container {
  @include mq($until: ipadL) {
    height: 100vh;

    .home__title {
      align-self: flex-end;
    }

    .home__caption {
      align-self: flex-start;
    }
  }
}

.home__caption {
  font-size: font-size(xs);
  margin-block-start: 1.2em;
  margin-block-end: 1.2em;
}
</style>
